/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { ReactChildren, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface IContainerProps {
  children?: ReactChildren;
  backgroundImage?: string;
}

const SIGN_IN_ILLUSTRATION = require('../../assets/signin.svg');

export const PageContainer = ({
  children,
  backgroundImage,
}: ISignUpPageProps) => {
  return (
    <main>
      <section
        className="mt-5 mt-lg-0 m-sm-5 bg-soft d-flex justify-content-center"
        style={{ height: '100vh' }}
      >
        <Row
          className="justify-content-center form-bg-image mt-2 w-100"
          // style={{ backgroundImage: `url(${backgroundImage})` }}
          style={{ overflowY: 'auto' }}
        >
          {children}
        </Row>
      </section>
    </main>
  );
};

PageContainer.defaultProps = {
  backgroundImage: SIGN_IN_ILLUSTRATION,
};
